import React from 'react'

import { Typography } from '@material-ui/core'

import { formatPrice } from 'common/utils/format'
import ProductPriceTypography from 'artkive/components/PageSections/ProductPriceTypography'
import { NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import { PRICING } from 'artkive/utils/constants'
import routes from 'artkive/utils/routes'

import ArtBooks from 'images/ecom/pricing/ArtBooks.png'
import Mosaics from 'images/ecom/pricing/Mosaics.png'
import StorageBadge from 'images/ecom/StorageBadge.svg'

import { BadgeWrapper, Image, MosaicsBadgeWrapper, MosaicsImage } from './YouWillAlsoLoveCarousel.style'

export const BOOK_SLIDE = {
  title: 'Kids Art Book',
  description: 'A vibrant hardcover book that showcases artwork and holds memories',
  buttonLabel: 'See Kids Art Books',
  href: routes.books,
  trackerEvent: NAVIGATION.ART_BOOK_CLICK,
  trackerOptions: {
    section: 'you_will_also_love_carousel',
  },
  bgColor: '#D3EFFB',
  image: <Image src={ArtBooks} />,
  badge: (
    <BadgeWrapper>
      <img src={StorageBadge} alt='+ 3 Months Storage' />
    </BadgeWrapper>
  ),
  price: (
    <strong>
      Starting at{' '}
      <Typography variant='h2' component='span'>
        {formatPrice(PRICING.books.base, 'short')}
      </Typography>{' '}
      for a {PRICING.books.minPages}-page Book
    </strong>
  ),
}

export const getMosaicSlide = (mosaicPricing) => ({
  title: 'Framed Mosaic',
  description: 'A bright and beautiful conversation piece that puts your child’s creativity front and center.',
  buttonLabel: 'See Mosaics',
  href: routes.mosaics,
  trackerEvent: NAVIGATION.MOSAIC_CLICK,
  trackerOptions: {
    section: 'you_will_also_love_carousel',
  },
  bgColor: '#E9E6F1',
  image: <MosaicsImage src={Mosaics} />,
  badge: (
    <MosaicsBadgeWrapper>
      <img src={StorageBadge} alt='+ 3 Months Storage' />
    </MosaicsBadgeWrapper>
  ),
  badgeAlt: '+ 3 Months Storage',
  price: (
    <strong>
      Starting at{' '}
      <ProductPriceTypography size='small'>{formatPrice(mosaicPricing.small.price, 'short')}</ProductPriceTypography>{' '}
      for {mosaicPricing.small.name} Mosaic
    </strong>
  ),
})
